module.exports = __webpack_public_path__ + "images/advcash-65bd31.svg";